var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"head",staticClass:"tabs-head",class:_vm.headClass},[_vm._t("default"),_c('div',{staticClass:"line-bg"}),_c('div',{ref:"line",staticClass:"line"}),_c('div',{staticClass:"actions-wrapper"},[_vm._t("actions")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }